import React, { memo, SVGProps } from 'react'

export const Logging = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.86496 4.58496H15.8438C16.2413 4.58496 16.5638 4.2624 16.5638 3.86496C16.5638 3.46752 16.2413 3.14496 15.8438 3.14496H3.86496C3.46752 3.14496 3.14496 3.46752 3.14496 3.86496C3.14496 4.2624 3.46752 4.58496 3.86496 4.58496Z"
      fill="currentColor"
    />
    <path
      d="M11.4518 19.415H3.86592C3.46848 19.415 3.14592 19.7376 3.14592 20.135C3.14592 20.5325 3.46848 20.855 3.86592 20.855H11.4518C11.8493 20.855 12.1718 20.5325 12.1718 20.135C12.1718 19.7376 11.8493 19.415 11.4518 19.415Z"
      fill="currentColor"
    />
    <path
      d="M20.136 6.76032H3.86496C3.46752 6.76032 3.14496 7.08288 3.14496 7.48032C3.14496 7.87776 3.46752 8.20032 3.86496 8.20032H20.135C20.5325 8.20032 20.855 7.87776 20.855 7.48032C20.855 7.08288 20.5334 6.76032 20.136 6.76032Z"
      fill="currentColor"
    />
    <path
      d="M14.975 10.2384H4.7328C3.8592 10.2384 3.14688 10.9498 3.14496 11.8262V15.5136C3.14496 16.3891 3.85728 17.1014 4.7328 17.1014H14.975C15.8506 17.1014 16.5629 16.3891 16.5629 15.5136V11.8262C16.5629 10.9507 15.8506 10.2384 14.975 10.2384ZM15.1229 15.5136C15.1229 15.5952 15.0566 15.6614 14.975 15.6614H4.7328C4.6512 15.6614 4.58496 15.5952 4.58496 15.5136V11.8282C4.58496 11.7456 4.6512 11.6784 4.7328 11.6784H14.975C15.0566 11.6784 15.1229 11.7446 15.1229 11.8262V15.5136Z"
      fill="currentColor"
    />
  </svg>
))
